import axios from 'axios';
const BASE = 'https://fitnesstrac-kr.herokuapp.com/api';

export default async function LogInUser(username, password){
    
    try {
      const {data} = await axios.post(`${BASE}/users/login`, {
        username,
        password
      });
      
      return data
    } catch (error) {
      console.error(error);
    } 
}